import React from 'react' // eslint-disable-line no-unused-vars
import '../../css/forms/default-forms.css'
import { connect } from 'react-redux'
import { addNotification as notify } from 'reapop'
import CountryAwareComponent from '../CountryAwareComponent'
import HeroImage from '../HeroImage'
import { RingLoader } from 'react-spinners'
import { v4 as uuidv4 } from 'uuid'
import { triggerSSO } from '../InitiateSSO'
import { api } from '../index.api'
import Footer from '../Footer'
import { isMobileDevice } from '../../functions.js'
import ListPagination from '../digitalAssistant/ListPagination'
import imgHeaderCongressesMobile from './assets/img_header_congresses_mobile.jpg'
import imgHeaderCongresses from './assets/img_header_congresses.jpg'
import Select from '../../forms/select-congress'

class Congresses extends CountryAwareComponent {
  constructor(props) {
    super(props)

    this.disclaimer = 'These non-promotional scientific presentations were presented by AbbVie at the scientific congress ' +
      'referenced above and are intended for healthcare professionals ​which were in attendance at ​such congress​. ' +
      'See full disclosures within the individual presentations. If you have a question, please contact AbbVie Medical Information.'

    this.congressContentUrl = 'Unassigned'

    this.includeUpcomingOptions = [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]

    this.pageSizeOptions = [
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '10', label: '10' },
      { value: '20', label: '20' },
      { value: '50', label: '50' },
      { value: '100', label: '100' }
    ]

    this.defaultPageSize = isMobileDevice() ? '4' : '10'

    const filterFields = {
      therapeuticArea: {
        name: 'therapeuticArea',
        value: { value: 'All', label: 'All Therapeutic Areas' },
        rules: {
          title: 'Therapeutic Area'
        }
      },
      includeUpcoming: {
        name: 'includeUpcoming',
        value: { value: 'No', label: 'No' },
        rules: {
          title: 'Include Upcoming Events'
        }
      },
      pageSize: {
        name: 'pageSize',
        value: this.pageSizeOptions.filter(item => item.value === this.defaultPageSize)[0],
        rules: {
          title: 'Items per page'
        }
      }
    }

    this.state = {
      congressIntegrationMetadata: null,
      congressItems: null,
      searching: false,
      countryName: null,
      paginationMapKey: 'main',
      paginationMap: this.initPaginationMapMain(0),
      paginationMatchingItemCount: 0,
      paginationActionDummyCounter: 0, // Dummy counter to force React to reload the table
      filterFields: filterFields,
    }

    this.componentName = 'Congresses'
    this.loadCongresses = this.loadCongresses.bind(this)
    this.showMessage = false
  }

  initPaginationMapMain = (itemsLength, pageSize) => {
    const totalPages = Math.ceil(itemsLength / pageSize)

    const mapItem = {
      pageNumber: 1,
      pageSize: pageSize,
      totalPages: totalPages
    }
    const paginationMap = new Map()
    paginationMap.set('main', mapItem)

    return paginationMap
  }

  getTodayUtc = () => {
    const d = new Date()
    const day = d.getUTCDate().toString()
    const month = (d.getUTCMonth() + 1).toString()
    const year = d.getUTCFullYear().toString()

    return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0')
  }

  isUpcomingCongress = congressStartDate => {
    return congressStartDate > this.getTodayUtc()
  }

  setPaginationMapItemPageNumber = (paginationMapKey, pageNumber) => {
    const paginationMap = this.state.paginationMap
    const paginationMapItem = paginationMap.get(paginationMapKey)
    paginationMapItem.pageNumber = pageNumber
    paginationMap.set(paginationMapKey, paginationMapItem)
    const paginationActionDummyCounter = this.state.paginationActionDummyCounter + 1
    this.setState({
      paginationMap: paginationMap,
      paginationActionDummyCounter: paginationActionDummyCounter
    })
  };

  componentDidMount() {
    this.loadCongresses({})
  }

  loadCongresses(postData, callbackFn) {
    this.setState({ congressIntegrationMetadata: null }, function () {
      this.forceUpdate()
    })

    this.showMessage = false
    this.setState({ searching: true })

    api.loadCongressIntegration(
      {},
      this._searchSuccessHandler.bind(this, postData),
      this._searchFailureHandler.bind(this)
    )
  }

  _searchSuccessHandler = (postData, response) => {
    if (response.status === 200) {
      response.json().then(responseJson => {
        const congressIntegrationMetadata = responseJson
        if (congressIntegrationMetadata == null) {
          this.showMessage = true
        }
        this.setState({ searching: false })

        const filteredItems = this.getFilteredItems(congressIntegrationMetadata.Congresses)

        const paginationMap = this.initPaginationMapMain(filteredItems.length, isMobileDevice() ? 4 : 10)
        const paginationActionDummyCounter = this.state.paginationActionDummyCounter + 1
        this.setState({
          paginationMap: paginationMap,
          congressIntegrationMetadata: congressIntegrationMetadata,
          congressItems: filteredItems,
          paginationMatchingItemCount: filteredItems.length,
          paginationActionDummyCounter: paginationActionDummyCounter
        }, function () {
          this.forceUpdate()
        })
      })
    } else if (response.status === 401) {
      this._showNotification(
        'Error',
        'You are not authorized to perform this action. Please log in again.',
        'error'
      )
      setTimeout(() => triggerSSO(this.props.pageContent.content.lang), 3000)
    } else {
      this._showNotification(
        'Error',
        'Error occurred while submitting query',
        'error'
      )
      this.setState({ searching: false })
    }
  }

  _searchFailureHandler = error => { /* eslint-disable-line */
    this.setState({ searching: false })
    this._showNotification('Error', 'Unexpected error occurred!', 'error')
  }

  setSearchAuditId = searchAuditId => {
    this.setState({ searchAuditId })
  }

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 3000
    })
  }

  getMonthName = mm => {
    switch (mm) { // eslint-disable-line default-case
      case '01':
        return 'Jan' // 'January'
      case '02':
        return 'Feb' // 'February'
      case '03':
        return 'Mar' // 'March'
      case '04':
        return 'Apr' // 'April'
      case '05':
        return 'May'
      case '06':
        return 'Jun' // 'June'
      case '07':
        return 'Jul' // 'July'
      case '08':
        return 'Aug' // 'August'
      case '09':
        return 'Sep' // 'September'
      case '10':
        return 'Oct' // 'October'
      case '11':
        return 'Nov' // 'November'
      case '12':
        return 'Dec' // 'December'
    }

    return ''
  }

  formatDateRange = (startDate, endDate) => {
    const arStart = startDate.split('-') // Expecting YYYY-MM-DD
    const arEnd = endDate.split('-')

    // Remove leading spaces
    arStart[2] = parseInt(arStart[2], 10)
    arEnd[2] = parseInt(arEnd[2], 10)

    if (arStart[0] === arEnd[0]) { // YYYY
      if (arStart[1] === arEnd[1]) { // MM
        if (arStart[2] === arEnd[2]) { // DD
          return `${this.getMonthName(arStart[1])} ${arStart[2]}, ${arStart[0]}` // Month DD, YYYY
        } else {
          return `${this.getMonthName(arStart[1])} ${arStart[2]} - ${arEnd[2]}, ${arStart[0]}` // Month DD - DD, YYYY
        }
      } else {
        return `${this.getMonthName(arStart[1])} ${arStart[2]} - ${this.getMonthName(arEnd[1])} ${arEnd[2]}, ${arStart[0]}` // Month DD - Month DD, YYYY
      }
    }

    return `${this.getMonthName(arStart[1])} ${arStart[2]}, ${arStart[0]} - ${this.getMonthName(arEnd[1])} ${arEnd[2]}, ${arEnd[0]}` // Month DD, YYYY - Month DD, YYYY
  }

  renderCongressDetail = item => {
    if (item == null) {
      return null
    }

    return (
      <div
        style={{
          border: '1px solid #aaaaaa',
          borderRadius: '10px',
          padding: '18px 20px 22px 20px'
        }}
      >
        <table>
          <tbody>
            <tr>
              <td style={{
                lineHeight: '18px'
              }}
              >
                <span style={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                  wordBreak: 'break-word',
                  lineHeight: '10px'
                }}
                >
                  {`${item.CongressName}`}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  paddingTop: '2px',
                  lineHeight: '19px'
                }}
              >
                <span style={{
                  wordBreak: 'break-word',
                  fontSize: '14px',
                  lineHeight: '10px'
                }}
                >
                  {item.TherapeuticArea.length === 0
                    ? null
                    : (
                      item.TherapeuticArea.map(m => {
                        return (
                          <span>
                            <span>{m}</span>
                            <i
                              className='fa fa-circle'
                              style={{
                                fontSize: '6px',
                                padding: '0px 10px 0px 10px',
                                color: '#071D49',
                                verticalAlign: 'middle',
                                lineHeight: '14px'
                              }}
                            />
                          </span>)
                      }
                      )
                    )
                  }
                  {this.formatDateRange(item.StartDate, item.EndDate)}
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ paddingTop: '13px' }}>
                {this.isUpcomingCongress(item.StartDate)
                  ? <span key={`material${uuidv4()}`}><i>Upcoming</i></span>
                  : (item.Materials.map(m => m.ActiveCount).reduce((acc, val) => acc + val, 0) > 0 // Get ActiveCount sum
                    ? (
                      item.Materials.filter(item => item.ActiveCount > 0).map((material, index) =>
                        <span key={`material${uuidv4()}`}>
                          <a
                            href={material.ContentUri}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            <span style={{
                              wordBreak: 'break-word',
                              borderBottom: '1px solid #2f9ece',
                              color: '#071D49'
                            }}
                            >
                              {`${material.Type} (${material.ActiveCount})`}
                            </span>
                          </a>
                          {index < (item.Materials.filter(item => item.ActiveCount > 0).length - 1)
                            ? (
                              <span style={{ padding: '0px 6px 0px 6px' }}>|</span>)
                            : null}
                        </span>
                      ))
                    : (
                      <span style={{ color: '#071D49' }}>
                        {item.Materials.map(m => m.PendingCount).reduce((acc, val) => acc + val, 0) > 0
                          ? 'Materials are in preparation'
                          : (item.Materials.map(m => m.ExpiredCount).reduce((acc, val) => acc + val, 0)
                            ? 'Materials are no longer available'
                            : 'No materials available')}
                      </span>))}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  setTherapeuticAreaFilter = value => {
    const filterFields = this.state.filterFields
    filterFields.therapeuticArea.value = value

    const filteredItems = this.getFilteredItems(this.state.congressIntegrationMetadata.Congresses)
    const paginationMap = this.initPaginationMapMain(filteredItems ? filteredItems.length : 0, filterFields.pageSize.value.value)

    const paginationActionDummyCounter = this.state.paginationActionDummyCounter + 1
    this.setState({
      congressItems: filteredItems,
      filterFields: filterFields,
      paginationMap: paginationMap,
      paginationMatchingItemCount: filteredItems.length,
      paginationActionDummyCounter: paginationActionDummyCounter
    })
  }

  setIncludeUpcomingFilter = value => {
    const filterFields = this.state.filterFields

    filterFields.includeUpcoming.value = value

    const filteredItems = this.getFilteredItems(this.state.congressIntegrationMetadata.Congresses)
    const paginationMap = this.initPaginationMapMain(filteredItems ? filteredItems.length : 0, filterFields.pageSize.value.value)

    const paginationActionDummyCounter = this.state.paginationActionDummyCounter + 1
    this.setState({
      congressItems: filteredItems,
      filterFields: filterFields,
      paginationMap: paginationMap,
      paginationMatchingItemCount: filteredItems.length,
      paginationActionDummyCounter: paginationActionDummyCounter
    })
  }

  setPageSizeFilter = value => {
    const filterFields = this.state.filterFields
    filterFields.pageSize.value = this.pageSizeOptions.filter(item => item.value === value)[0]

    const filteredItems = this.getFilteredItems(this.state.congressIntegrationMetadata.Congresses)
    const paginationMap = this.initPaginationMapMain(filteredItems ? filteredItems.length : 0, value)

    const paginationActionDummyCounter = this.state.paginationActionDummyCounter + 1
    this.setState({
      congressItems: filteredItems,
      filterFields: filterFields,
      paginationMap: paginationMap,
      paginationMatchingItemCount: filteredItems.length,
      paginationActionDummyCounter: paginationActionDummyCounter
    })
  }
  temp = (TList, TFilter) => {
    if (TList.includes(TFilter)) { return true }
    return false
  }
  
  getFilteredItems = (congresses) => {
    let filteredItems = congresses
    const therapeuticAreaFilter = this.state.filterFields.therapeuticArea.value
    if (therapeuticAreaFilter !== 'All' && therapeuticAreaFilter.length > 0) {
      filteredItems = congresses.filter(item => this.temp(item.TherapeuticArea, therapeuticAreaFilter))
    }

    const includeUpcomingFilter = this.state.filterFields.includeUpcoming.value.value
      ? this.state.filterFields.includeUpcoming.value.value : this.state.filterFields.includeUpcoming.value

    if (includeUpcomingFilter === 'No') {
      const recentOnlyItems = filteredItems.filter(item => !this.isUpcomingCongress(item.StartDate))
      filteredItems = recentOnlyItems
    }

    return filteredItems
  }

  renderRecentSection = () => {
    if (this.state.congressIntegrationMetadata == null) {
      return null
    }

    const paginationMapItem = this.state.paginationMap.get(this.state.paginationMapKey)
    const pageNumber = paginationMapItem.pageNumber
    const pageSize = paginationMapItem.pageSize
    const totalPages = paginationMapItem.totalPages

    const filteredItemsSlice = this.state.congressItems.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)

    const filteredItemsSlicePairs = []
    for (let i = 0; i < filteredItemsSlice.length; i += 2) {
      if (i < filteredItemsSlice.length - 1) {
        filteredItemsSlicePairs.push({
          left: filteredItemsSlice[i],
          right: filteredItemsSlice[i + 1]
        })
      } else {
        filteredItemsSlicePairs.push({
          left: filteredItemsSlice[i],
          right: null
        })
      }
    }

    return (
      <div>
        {filteredItemsSlicePairs.map(pair =>
          <div
            key={`item${uuidv4()}`}
            className='row'
          >
            {isMobileDevice()
              ? null
              : (
                <div
                  className='col-lg-1'
                  key={`key${uuidv4()}`}
                  style={{ paddingTop: '10px', paddingRight: '4px' }}
                >
                  <span>&nbsp;</span>
                </div>)}
            <div
              className='col-lg-5'
              key={`key${uuidv4()}`}
              style={{ paddingTop: '10px', paddingRight: (isMobileDevice() ? '14px' : '0px') }}
            >
              {this.renderCongressDetail(pair.left)}
            </div>
            <div
              className='col-lg-5'
              key={`key${uuidv4()}`}
              style={{ paddingTop: '10px', paddingRight: (isMobileDevice() ? '14px' : '0px') }}
            >
              {this.renderCongressDetail(pair.right)}
            </div>
            {isMobileDevice()
              ? null
              : (
                <div
                  className='col-lg-1'
                  key={`key${uuidv4()}`}
                  style={{ paddingTop: '10px', paddingRight: (isMobileDevice() ? '10px' : '0px') }}
                >
                  <span>&nbsp;</span>
                </div>)}
          </div>
        )}
        <div
          className='row'
        >
          <div
            className='col-lg-12'
            key={`key${uuidv4()}`}
            style={{ paddingTop: '10px', paddingRight: (isMobileDevice() ? '14px' : '0px') }}
          >
            <ListPagination
              pageNumber={pageNumber}
              pageSize={pageSize}
              totalPages={totalPages}
              setPageNumber={this.setPaginationMapItemPageNumber}
              paginationMapKey={this.state.paginationMapKey}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.congressIntegrationMetadata == null) {
      return null
    }
    let therapeuticAreaOptions = this.state.congressIntegrationMetadata.TherapeuticAreas.map(item => ({ value: item, label: item }))
    therapeuticAreaOptions = [{ value: 'All', label: 'All Therapeutic Areas' }, ...therapeuticAreaOptions]

    const formTitle = 'Congresses'

    const jsx =
      <div className='page-container'>
        <div className='page-content'>
          <HeroImage title={formTitle} imageMobile={imgHeaderCongressesMobile} imageDesktop={imgHeaderCongresses} />
          <div className='container' style={{ border: '0px solid blue', marginBottom: '5px' }}>
            <div className='col-xl-12'>
              <RingLoader color='#071d49' loading={this.state.searching} />
            </div>
            <div className='col-xl-12' style={{ paddingLeft: '0px', border: '0px solid green' }}>
              {this.state.congressItems.length === 0
                ? null
                : null /* this.renderSectionTitle('Recent', this.state.recentSectionIsExpanded, true) */}
            </div>
            {this.state.congressIntegrationMetadata == null
              ? null
              : (
                <div
                  className='row'
                  style={{
                    paddingLeft: '0px',
                    paddingBottom: '10px'
                  }}
                >
                  {isMobileDevice()
                    ? null
                    : (
                      <div className='col-lg-1 col-xl-1'>
                        <span>&nbsp;</span>
                      </div>)}
                  <div className='col-lg-3 col-xl-3' style={{ paddingTop: '5px' }}>
                    <Select
                      id='therapeuticAreaFilter'
                      searchable
                      clearable={false}
                      options={therapeuticAreaOptions}
                      field={this.state.filterFields.therapeuticArea}
                      validate={(e, field) => { return true }}
                      onChange={value => (this.setTherapeuticAreaFilter(value))}
                    />
                  </div>
                  <div className='col-lg-2 col-xl-2' style={{ paddingTop: (isMobileDevice() ? '25px' : '5px') }}>
                    <Select
                      id='includeUpcomingFilter'
                      searchable
                      clearable={false}
                      options={this.includeUpcomingOptions}
                      field={this.state.filterFields.includeUpcoming}
                      validate={(e, field) => { return true }}
                      onChange={value => (this.setIncludeUpcomingFilter(value))}
                    />
                  </div>
                  <div
                    className='col-lg-5 col-xl-5'
                    style={{ paddingTop: '5px' }}
                  >
                    <div className='row'>
                      <div className='col-lg-6 col-xl-6'>
                        <span>&nbsp;</span>
                      </div>
                      <div className='col-lg-3 col-xl-3'>
                        <Select
                          id='pageSizeFilter'
                          searchable
                          clearable={false}
                          options={this.pageSizeOptions}
                          field={this.state.filterFields.pageSize}
                          validate={(e, field) => { return true }}
                          onChange={value => (this.setPageSizeFilter(value))}
                        />
                      </div>
                      <div
                        className='col-lg-3 col-xl-3'
                        style={{
                          textAlign: 'right',
                          fontSize: '14px',
                          paddingTop: '25px'
                        }}
                      >
                        <span><i>{`Total Items: ${this.state.paginationMatchingItemCount}`}</i></span>
                      </div>
                    </div>
                  </div>
                  {isMobileDevice()
                    ? null
                    : (
                      <div className='col-lg-1 col-xl-1'>
                        <span>&nbsp;</span>
                      </div>)}
                </div>)}
            {this.renderRecentSection()}
            <div className='row m-t-20'>
              <div className='col-lg-1 col-xl-1'>
                <span>&nbsp;</span>
              </div>
              <div
                className='col-lg-10 col-xl-10'
                style={{
                  paddingRight: '0px',
                  border: '0px solid blue'
                }}
              >
                {this.renderDisclaimer(true)}
              </div>
              <div className='col-lg-1 col-xl-1'>
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

    return this.countriesMatched() ? jsx : null
  }

  renderDisclaimer = includeBorder => {
    if (includeBorder) {
      return (
        <div
          style={{
            fontSize: '14px',
            padding: '15px',
            marginTop: '5px',
            marginBottom: '15px',
            border: '1px solid #aaaaaa',
            borderRadius: '10px'
          }}
        >
          <span>{this.disclaimer}</span>
        </div>)
    }

    return (
      <div
        style={{
          fontSize: '12px',
          paddingLeft: '0px',
          marginTop: '5px',
          marginBottom: '5px'
        }}
      >
        <span>{this.disclaimer}</span>
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions
  }
}

export default connect(
  mapStateToProps,
  { notify }
)(Congresses)


// WEBPACK FOOTER //
// ./src/mi-app/congresses/Congresses.js



// WEBPACK FOOTER //
// ./src/mi-app/congresses/Congresses.js